// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { purchasedProductCardStyles } from "@insite/content-library/Components/PurchasedProductCard";
import PlusRound from "@rugby/XDL/Icons/PlusRound";
import { CustomMediaQuery, ellipsis } from "@rugby/XDL/Utilities";
import { css } from "styled-components";

const MediaQuery = CustomMediaQuery();
const imageWidth = 116;

purchasedProductCardStyles.leftColumnGridItem = {
    css: css`
        flex-basis: ${imageWidth}px;
        flex-shrink: 0;
        max-width: none;
    `,
};

purchasedProductCardStyles.rightColumnGridItem = {
    css: css`
        flex-grow: 1;
        flex-basis: calc(100% - ${imageWidth}px);
        max-width: none;
    `,
};

purchasedProductCardStyles.productImage = {
    image: {
        css: css`
            max-width: ${imageWidth}px;
            width: ${imageWidth}px;
        `,
    },
};

purchasedProductCardStyles.descriptionGridItem = {
    ...purchasedProductCardStyles.descriptionGridItem,
    css: css`
        ${purchasedProductCardStyles.descriptionGridItem?.css}
        &&& {
            margin-top: 5px;
            margin-bottom: 10px;
        }
    `,
};

purchasedProductCardStyles.partNumbersGridItem = {
    ...purchasedProductCardStyles.partNumbersGridItem,
    css: css`
        ${purchasedProductCardStyles.partNumbersGridItem?.css}
        &&& {
            margin-bottom: 10px;
        }
    `,
};

const productPartNumbersDefaultStyle = {
    labelText: {
        css: css`
            font-weight: normal;
            font-size: 14px;
            letter-spacing: 0;
            line-height: 21px;
            padding-right: 4px;
        `,
    },
    valueText: {
        css: css`
            flex-grow: 0;
            font-size: 14px;
            letter-spacing: 0;
            line-height: 21px;
        `,
    },
};

purchasedProductCardStyles.partNumbersStyles = {
    ...purchasedProductCardStyles.partNumbersStyles,
    erpNumberLabelText: productPartNumbersDefaultStyle.labelText,
    customerNameLabelText: productPartNumbersDefaultStyle.labelText,
    manufacturerItemLabelText: productPartNumbersDefaultStyle.labelText,
    erpNumberValueText: productPartNumbersDefaultStyle.valueText,
    customerNameValueText: productPartNumbersDefaultStyle.valueText,
    manufacturerItemValueText: productPartNumbersDefaultStyle.valueText,
};

purchasedProductCardStyles.priceGridItem = {
    ...purchasedProductCardStyles.priceGridItem,
    css: css`
        ${purchasedProductCardStyles.priceGridItem?.css}
        &&& {
            padding-left: 20px;
            ${MediaQuery.gt("md")} {
                align-items: flex-end;
            }

            ${MediaQuery.lte("md")} {
                margin-top: 16px;
                margin-bottom: 16px;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                padding: 0;
                max-width: 280px;
            }

            ${MediaQuery.gt("md")} {
                div[class^="FormFieldStyle"] {
                    max-width: 160px;
                }
            }
        }
    `,
};

purchasedProductCardStyles.actionsContainer = {
    ...purchasedProductCardStyles.actionsContainer,
    css: css`
        ${purchasedProductCardStyles.actionsContainer?.css}
        &&& {
            ${MediaQuery.lte("md")} {
                align-items: center;
                justify-content: center;
                max-width: 280px;
            }
        }
    `,
};

purchasedProductCardStyles.priceStyles = {
    ...purchasedProductCardStyles.priceStyles,
    wrapper: {
        css: css`
            ${purchasedProductCardStyles.priceStyles?.wrapper?.css}
            &&& {
                margin-bottom: 16px;
                ${MediaQuery.lte("md")} {
                    flex-shrink: 0;
                    margin-right: 8px;
                    margin-bottom: 0;
                }
            }
        `,
    },
};

const descriptionStyles = {
    size: 16,
    color: "secondary",
    css: css`
        letter-spacing: 0;
        line-height: 22px;
        ${ellipsis(2, 22)}
    `,
};

purchasedProductCardStyles.descriptionStyles = {
    productDetailLink: {
        color: "secondary",
        typographyProps: {
            ...descriptionStyles,
        },
    },
    productDetailDescription: {
        ...descriptionStyles,
    },
};

purchasedProductCardStyles.addToListLink = {
    link: {
        color: "secondary",
        typographyProps: {
            size: 14,
            ellipsis: true,
            css: css`
                letter-spacing: 0;
                line-height: 22px;
            `,
        },
        icon: {
            iconProps: {
                src: PlusRound,
                color: "secondary",
                size: 12,
            },
        },
    },
};

purchasedProductCardStyles.addToCartButton = {
    css: css`
        ${purchasedProductCardStyles.addToCartButton?.css}
        padding: 0;
    `,
};
